import { Link } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";

export default function MarketTerms() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="max-w-3xl mx-auto px-6 py-24 md:py-32">
        {/* Back link */}
        <Link
          to="/market"
          className="inline-flex items-center gap-2 text-sm font-head uppercase tracking-[0.15em] mb-10 hover:text-[#F5C842] transition-colors"
          style={{ color: "#3ECFB2" }}
        >
          <ArrowLeft className="w-4 h-4" /> Back to Market
        </Link>

        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <Shield className="w-6 h-6" style={{ color: "#F5C842" }} />
            <span className="font-head text-xs uppercase tracking-[0.3em]" style={{ color: "#F5C842" }}>
              Legal
            </span>
          </div>
          <h1 className="font-head text-3xl md:text-4xl font-bold uppercase tracking-[0.1em] mb-4">
            Hylas Companion<br />
            <span style={{ color: "#F5C842" }}>Marketplace Terms</span>
          </h1>
          <p className="text-white/50 text-sm">
            Effective upon first login to Hylas Market. Required for platform access.
          </p>
        </div>

        {/* Divider */}
        <div className="h-px mb-10" style={{ background: "linear-gradient(to right, #F5C842, transparent)" }} />

        {/* Terms Content */}
        <div className="space-y-8 text-white/80 leading-relaxed">
          <div className="p-6 rounded-none border-l-4" style={{ background: "#111111", borderLeftColor: "#F5C842" }}>
            <p className="text-sm text-white/50 uppercase tracking-[0.2em] font-head mb-3">Agreement</p>
            <p>
              By logging into and accessing the Hylas Companion Market ("Marketplace"), you agree to the following terms:
            </p>
          </div>

          {[
            {
              num: "1",
              title: "Proprietary Marketplace Intellectual Property",
              body: "The structure, workflow, pricing models, driver cards, bidding systems and concept of the Hylas Companion Market are the confidential intellectual property of Andrej Sasaroga DBA Hylas Companion. Copying, scraping, reverse-engineering or duplicating this system is strictly prohibited.",
            },
            {
              num: "2",
              title: "Final Administrative Discretion",
              body: "Bids appear live on the Market as soon as they are placed. A bid is a formal offer. Hylas Companion has absolute and sole discretion to choose and approve whichever bid it wants for any driver, regardless of the amount or the order in which bids were placed. A bid does not guarantee a driver assignment and does not become binding until Hylas Companion approves it. Approval of a bid does not create an employment contract between Hylas Companion and any driver.",
            },
            {
              num: "3",
              title: "Carrier Non-Circumvention and Fees",
              body: "Carriers agree that all drivers listed on the Market are proprietary candidates of Hylas Companion. Attempting to identify, solicit or hire any driver outside the platform to avoid Hylas fees is a breach of these terms. Once Hylas Companion approves a bid, the carrier agrees to pay the selected fee structure (Standard 50/50, One-Time Discount, or Hylas Weekly Flex) when a Qualified Hire occurs. A Qualified Hire means the driver starts working for the carrier.",
            },
            {
              num: "4",
              title: "Hylas Weekly Flex Includes Market Access",
              body: "Hylas Weekly Flex covers both the driver placement and the carrier's subscription to use the Hylas Market. A carrier's access to the Market under Hylas Weekly Flex lasts only while the weekly payments are active and up to date. Hylas Companion may pause or end Market access if payments stop. (Note: During the introductory promo period, free access applies as a loyalty reward).",
            },
            {
              num: "5",
              title: "Driver Data and Photo Consent",
              body: "Drivers authorize Hylas Companion to display their name, state and cropped CDL face image on Market candidate cards. CDL numbers, addresses, emails and phone numbers stay confidential and are visible only to authorized Hylas recruiters and safety personnel, and only as needed.",
            },
            {
              num: "6",
              title: "Hylas Weekly Flex and Driver Royalties",
              body: "Driver royalty payments (a 10% share of active Hylas Weekly Flex fees) are promotional placement rewards funded by Hylas Companion. Royalty eligibility requires ongoing active employment in good standing with the assigned carrier, and Hylas Companion decides when a driver is in good standing. Drivers pay no fees to Hylas Companion for the use of the Market.",
            },
            {
              num: "7",
              title: "Driver Documentation Completion Bonus — $65",
              body: "Drivers who complete all required documentation on the platform (MVR, PSP, and Clearinghouse — plus Previous CDL if applicable) AND begin active employment with a Hylas Companion-approved carrier are eligible for a one-time $65 Documentation Completion Bonus. This bonus is funded and paid solely by Hylas Companion, not by the carrier. Eligibility is contingent on verified document completion and confirmed first day of employment. Hylas Companion reserves the right to verify all documents and determine payout timing prior to disbursement.",
            },
          ].map((section) => (
            <div key={section.num} className="space-y-2">
              <div className="flex items-start gap-4">
                <span
                  className="shrink-0 w-8 h-8 flex items-center justify-center font-head font-bold text-sm"
                  style={{ background: "#F5C842", color: "#0A0A0A" }}
                >
                  {section.num}
                </span>
                <div>
                  <h2 className="font-head text-sm font-bold uppercase tracking-[0.15em] text-white mb-2">
                    {section.title}
                  </h2>
                  <p className="text-sm text-white/70 leading-relaxed">{section.body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <p className="font-head text-xs uppercase tracking-[0.2em]" style={{ color: "#F5C842" }}>
              Hylas Companion, LLC
            </p>
            <p className="text-xs text-white/40 mt-1">
              Andrej Sasaroga DBA Hylas Companion · Recruiting Division
            </p>
          </div>
          <Link
            to="/market"
            className="inline-flex items-center gap-2 font-head text-xs uppercase tracking-[0.15em] px-6 py-3 transition-all duration-200"
            style={{ background: "#F5C842", color: "#0A0A0A" }}
          >
            Return to Market
          </Link>
        </div>
      </div>
    </div>
  );
}
